window.BAO.EVENTS = {
  CART_NOTE: {
    BEFORE_CHANGE: 'BEFORE_CHANGE',
    AFTER_CHANGE: 'AFTER_CHANGE',
  },
  QUANTITY_ADJUSTER: {
    CHANGE: 'BAO::EVENTS::QUANTITY_ADJUSTER::CHANGE',
  },
  PUSH_CART: {
    BEFORE_ADD: 'BEFORE_ADD',
    AFTER_ADD: 'AFTER_ADD',
    BEFORE_ADD_FROM_FORM: 'BEFORE_ADD_FROM_FORM',
    AFTER_ADD_FROM_FORM: 'AFTER_ADD_FROM_FORM',
    BEFORE_MULTIPLE_ADD: 'BEFORE_MULTIPLE_ADD',
    AFTER_MULTIPLE_ADD: 'AFTER_MULTIPLE_ADD',
    BEFORE_UPDATE_REMOVE_ITEM: 'BEFORE_UPDATE_REMOVE_ITEM',
    AFTER_UPDATE_REMOVE_ITEM: 'AFTER_UPDATE_REMOVE_ITEM',
    BEFORE_UPDATE_ITEM_QUANTITY: 'BEFORE_UPDATE_ITEM_QUANTITY',
    AFTER_UPDATE_ITEM_QUANTITY: 'AFTER_UPDATE_ITEM_QUANTITY',
    BEFORE_UPDATE_CART_ATTRIBUTES: 'BEFORE_UPDATE_CART_ATTRIBUTES',
    AFTER_UPDATE_CART_ATTRIBUTES: 'AFTER_UPDATE_CART_ATTRIBUTES',
    CHANGED: 'CHANGED',
  },
  PUSH_CART_FOOTER: {
    RENDERED: 'RENDERED',
  },
  TEMPLATE_CART: {
    RENDERED: 'RENDERED',
  },
  LOAD_MORE: {
    FETCHED_NEXT_PAGE: 'FETCHED_NEXT_PAGE',
    FETCHED_PREV_PAGE: 'FETCHED_PREV_PAGE',
  },
  VARIANT: {
    CHANGED: 'CHANGED',
  },
  COLLECTION: {
    AFTER_SORT_BUTTON_CLICK: 'AFTER_SORT_BUTTON_CLICK',
    DRAWER_BUTTON_CHANGED: 'DRAWER_BUTTON_CHANGED',
  },
  GRID_SWITCHER: {
    SWITCHED: 'SWITCHED',
    EXTERNAL_SWITCH: 'EXTERNAL_SWITCH',
  },
  MODAL: {
    SHIPPING: 'SHIPPING',
  },
}

window.BAO.eventBus = new window.BAO.EventBus()
window.BAO.dispatchEvent = window.BAO.eventBus.dispatchEvent.bind(
  window.BAO.eventBus,
)
